import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";

import { DialogButton } from "./CreditDialog.style";

import React from "react";
import { AsyncDialogProps } from "react-dialog-async";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useTranslation } from "react-i18next";

interface CreditDialogData {
  title: string;
  message: string;
  rows: any;
}

/**
 * This is an example confirmation dialog. It can be passed a title and message to display,
 * and will return a boolean representing if the user accepted the dialog or not.
 */
const CreditDialog: React.FC<AsyncDialogProps<CreditDialogData, boolean>> = ({
  open,
  handleClose,
  data
}) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={() => handleClose(false)}>
      <DialogTitle sx={{ fontSize: "1.0em", fontWeight: "bold" }}>
        {data.title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ fontSize: "1.0em", marginBottom: "2rem" }}>
          {data.message}
        </DialogContentText>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 300 }} size="small">
            <TableBody>
              {data.rows.map((row) => (
                <TableRow
                  key={row.name}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell
                    sx={{ fontSize: "0.9em", fontWeight: "bold" }}
                    component="th"
                    scope="row"
                  >
                    {row.name}
                  </TableCell>
                  <TableCell sx={{ fontSize: "0.9em" }}>{row.detail}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <DialogButton onClick={() => handleClose(false)}>
          {t("crediting.dialog.modal.header.close")}
        </DialogButton>
        <DialogButton onClick={() => handleClose(true)}>
          {t("crediting.dialog.modal.header.submit")}
        </DialogButton>
      </DialogActions>
    </Dialog>
  );
};

export default CreditDialog;
